export default __webpack_public_path__ + "static/media/ic_infor.689ab1cd.svg";